<template>
  <div :class="size" :style="inputStyle">
    <div
      class="input-group"
      :class="disabled ? 'disabled' : ''"
      :style="inputBoxStyle"
    >
      <input
        :type="type"
        class="form-control"
        :placeholder="placeholder"
        :value="modelValue"
        @input="updateValue($event)"
        @focusout="focusout($event.target.value)"
        min="0"
        :id="id"
        :disabled="disabled"
        :maxlength="maxLength"
        @focus="(e) => $emit('onFocus', e)"
        @blur="(e) => $emit('onBlur', e)"
        @keydown="(e) => $emit('keydown', e)"
        @keyup="(e) => $emit('onKeyup', e)"
      />
      <div v-if="unitRequired" class="input-group-append">
        {{ unitAppend }}
      </div>
      <slot name="input-icon"></slot>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'RexFormInput',
  emits: [
    'onFocusout',
    'onFocus',
    'onBlur',
    'keydown',
    'onKeyup',
    'update:modelValue',
  ],
  data() {
    return {
      inputVal: '',
    };
  },
  props: {
    unit: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    type: { type: String, default: 'text' },
    id: { type: String, required: true },
    size: { type: String, default: 'sm' },
    inputStyle: { type: String, default: '' },
    inputBoxStyle: { type: String, default: '' },
    unitRequired: { type: Boolean, default: false },
    modelValue: {},
    maxLength: { type: Number, default: -1 },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    emitValue() {
      this.$emit('update:modelValue', this.inputVal);
    },
    updateValue: function (event) {
      if (this.maxLength > 0) {
        event.target.value = event.target.value.slice(0, this.maxLength);
      }
      this.$emit('update:modelValue', event.target.value);
    },
    focusout: function (value) {
      this.$emit('onFocusout', value);
    },
  },
  // mounted() {
  //   if (this.updateVal) {
  //     this.inputVal = this.updateVal;
  //   }
  // },
  computed: {
    unitAppend() {
      if (this.unit === '') {
        return '';
      }
      return '| ' + this.unit;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-control {
  background-color: $bg-primary;
  color: $font-primary;
  //border: 0.0625 black solid;
  height: 100%;
}
.input-last {
  background-color: $bg-primary;
  border: 0.125em;
}
.sm {
  min-width: 12.5em;
}
.lg {
  min-width: 18.75em;
}
.input-group-text {
  color: $font-primary;
  background: $bg-primary;
  border: none;
}
.input-group-append {
  border-top-right-radius: 0.375em;
  border-bottom-right-radius: 0.375em;
  color: $font-primary;
  background-color: $bg-primary;
  padding: 0.3125em;
  text-align: left;
  white-space: nowrap;
  padding: 0;
}
.input-group {
  background: $bg-primary;
  border-radius: 0.375rem;
  border: 0.0625em $border-primary solid;
  height: 100%;
  flex-wrap: nowrap;
  padding: 0.3rem;
}
input[type='text'] {
  box-sizing: border-box;
  border: none;
  border-radius: 7px;
  background-color: $bg-primary;
  color: $font-primary;
}
input[type='password'] {
  box-sizing: border-box;
  border: none;
  border-radius: 7px;
  background-color: $bg-primary;
  color: $font-primary;
}
input[type='number'] {
  box-sizing: border-box;
  border: none;
  border-radius: 0.375rem;
  background-color: $bg-primary;
  color: $font-primary;
}
.cust-modal-input:focus {
  outline: none !important;
}
input:focus {
  outline: none !important;
  box-shadow: none;
}
.disabled {
  pointer-events: none;
  opacity: 0.7;
}
/* Hide spinner in firfox */
input[type='number'] {
  -moz-appearance: textfield;
}
/* Show spinner on hover/focus  in firefox*/
input[type='number']:hover,
input[type='number']:focus {
  -moz-appearance: auto;
}

/* Hide spinner in Safari */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Show spinner on hover/focus in Safari */
input[type='number']:hover::-webkit-inner-spin-button,
input[type='number']:focus::-webkit-inner-spin-button,
input[type='number']:hover::-webkit-outer-spin-button,
input[type='number']:focus::-webkit-outer-spin-button {
  -webkit-appearance: auto;
}
</style>
